//#region ../erd-editor-schema/dist/v3/schema/tableColumn.entity.js
var ColumnOption = {
	autoIncrement: 1,
	primaryKey: 2,
	unique: 4,
	notNull: 8,
	nameDerived: 16
};
var ColumnUIKey = {
	primaryKey: 1,
	foreignKey: 2
};
//#endregion
export { ColumnOption, ColumnUIKey };
